import api from '~/services/api';

export const fetchLojasInfo = async (l: number[]): Promise<any[]> => {
  const lojasUnicas = Array.from(new Set(l)).filter(Boolean);

  const requests = lojasUnicas.map(async (codLoja) => {
    const res = await api.get(`/lojas/${codLoja}`);
    const { data } = res.data;
    return { cod_loja: data.cod_loja, des_uf: data.des_uf };
  });

  return Promise.all(requests);
};
